import React, { PropsWithChildren, useMemo } from 'react';
import { createSafeContext } from '../util/createSafeContext';
import { FeatureFlagService } from './FeatureFlag';
import { SystemConfigService } from './SystemConfig';
import { DefaultTenantService, TenantService } from './Tenant';
import { DefaultUserInfoService, UserInfoService } from './UserInfo';

/**
 * This context functions as our service registry, allowing consuming components to access services.
 */
export interface ServiceContextValue {
    featureFlagService: FeatureFlagService;

    systemConfigService: SystemConfigService;
    tenantService: TenantService;

    userInfoService: UserInfoService;
}

const [ServiceContextProviderInner, useServiceContext, ServiceContext] =
    createSafeContext<ServiceContextValue>('Service');

export function ServiceContextProvider(props: PropsWithChildren<unknown>): React.JSX.Element {
    const value = useMemo(() => {
        const value: ServiceContextValue = {
            featureFlagService: new FeatureFlagService(),
            systemConfigService: new SystemConfigService(),
            tenantService: new DefaultTenantService(),
            userInfoService: new DefaultUserInfoService(),
        };
        return value;
    }, []);

    return <ServiceContextProviderInner value={value}>{props.children}</ServiceContextProviderInner>;
}

export { ServiceContext, useServiceContext };
